import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Segment } from 'semantic-ui-react';
import { PublicHomeNav } from '../../Common/PublicComponents/PublicHomeNav';
import { PublicSkipContentLink } from '../../Common/PublicComponents/PublicSkipContentLink';
import { PUBLIC_SITE_URL_ACTIVE_MAP } from '../../../App';
import { usePublicProviderList } from './usePublicProviderList';

export function PublicProviderList() {

    const [isLoading, data, updateCounter] = usePublicProviderList();

    useEffect(() => {
        equalizeHeightFeatures();
    }, [updateCounter]);

    function equalizeHeightFeatures() {
        $('.features').each(function () {
            var $this = $(this);
            var highestBox = 0;
            $this.find('.feature .feature__inner-content').each(function () {
                if ($(this) && ($(this).outerHeight() as number) > highestBox) {
                    highestBox = $(this).outerHeight() as number;
                }
            });
            $this.find('.feature__inner').height(highestBox);
        });
    }

    const dataLoaded: boolean = !isLoading && data && data.length > 0;
    return (
        <>
            <div className="wrapper">
                <PublicSkipContentLink />
                <PublicHomeNav publicSiteURLActiveMap={PUBLIC_SITE_URL_ACTIVE_MAP} />
                <div className="main" id="content">
                    <section className="section section-features section-offset">
                        <header className="section__head">
                            <div className="shell">
                                <div className="section__head-inner">
                                    <h1>Local Training & Education Opportunities</h1>

                                    <nav className="breadcrumbs section__breadcrumbs">
                                        <ul>
                                            <li>
                                                <Link className='public-site' to='/'>Home</Link>
                                            </li>

                                            <li className="is-current">Local Training & Education Opportunities </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </header>

                        <div className="section__body">
                            <div className="shell">
                                <div className="section__body-inner">
                                    {
                                        !dataLoaded &&
                                        <Segment loading style={{minHeight: '20rem'}}>

                                        </Segment>
                                    }
                                    {
                                        dataLoaded &&
                                        <ul className="features">
                                            {
                                                data.map((item, index) => {
                                                    return (
                                                        <li className="feature" key={item.id}>
                                                            <div className="feature__inner">
                                                                <div className="feature__inner-content">
                                                                    <div className="feature__icon">
                                                                        <div className={item.iconName || 'ico-dafault'}>
                                                                            <img aria-hidden src={`assets/images/svg/${item.iconName || 'ico-dafault'}.svg`} alt="" width="45" height="62" />
                                                                        </div>
                                                                    </div>
                                                                    <h2><Link className='public-site' to={`/EducationOpportunitiesList?pcid=${item.id}`}>{item.displayName}</Link></h2>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    );
                                                })
                                            }
                                        </ul>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}